import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class KitaBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Kita;
  get Icon(): React.ComponentType<SvgIconProps> {
    return ChildFriendlyIcon;
  }
}
